// Icon
import ICQuyTac from "./icons/ic-quytac.svg";
import ICDropdow from "./icons/ic-dropdow-mb.svg";
import ICDoiTuongThamGia from "./icons/doi-tuong-tham-gia.svg";
import ICLoaiTru from "./icons/loai-tru.svg";
import ICChevronDouble from "./icons/chevron-double-down.svg";
import ICDateDis from "./icons/date-dis.svg";
import ICAdd from "./icons/addPerson.svg";
import ICDate from "./icons/date.svg";
import ICChinhSua from "./icons/chinhsua.svg";
import ICBack from "./icons/ic-back.svg";
import ICMuaNgay from "./icons/ic-muangay.svg";
import ICLogoGCDK from "./icons/logoGC.png";
import ICBackHeader from "./icons/ic-back-breadCum.svg";
import ICBreadCum from "./icons/ic-breadcum.svg";
import ICEdit from "./icons/ic-edit.svg";
import ICXoa from "./icons/ic-xoa.svg";
import ICGiamGia from "./icons/ic-giamgia.png";
import ICWarning from "./icons/ic-warning.svg";
import ICThanhCong from "./icons/ic-thanhcong.svg";
import ICUser2 from "./icons/ic-user2.svg";
import ICMST from "./icons/ic-mst.svg";
import ICDiaChiVAT from "./icons/ic-diemden.svg";
import ICCongTy from "./icons/ic-congty.svg";
import ICXoa2 from "./icons/ic-xoa2.png";
import ICErr from "./icons/error_icon.svg";
import ICAddress from "./icons/icon_address.svg";
import ICMail from "./icons/Icon_mail.svg";
import ICMst from "./icons/Icon_MST.svg";
import LogoMIC from "./images/logo_MIC.png";


// Hình cho desktop
import CCCD from "./images/cccd.svg";
import BannerDK from "./images/web-export/banerMB.webp";
import QuyenLoi from "./images/web-export/quyenloi.webp";
import QuyTrinhBoiThuong from "./images/web-export/quy-trinh-boi-thuong.webp";
import khienBaoHiem from "./images/web-export/khienbaohiem.webp";
import TaiNanGapPhai from "./images/web-export/tainangapphai.webp";
import Banner2 from "./images/web-export/banner2.webp";
import Banner3 from "./images/web-export/banner3.webp";

// Hình cho mobile
import BannerMB from "./images/web-export/baner.webp";
import Banner2MB from "./images/web-export/banner2-mb.webp";
import Banner3MB from "./images/web-export/banner3-mb.webp";
import QuyenLoiMB from "./images/web-export/quyenloi-mb.webp";
import QuyTrinhBoiThuongMB from "./images/web-export/quy-trinh-boi-thuong-mb.webp";
import TaiNanGapPhaiMB from "./images/web-export/tainangapphai-mb.webp";
import CCCDMB from "./images/cccd-mb.png";

const variable = {
  ICQuyTac, ICDropdow, ICDoiTuongThamGia, ICLoaiTru, ICChevronDouble, ICEdit, ICXoa, ICGiamGia, ICWarning,
  ICDateDis,ICAdd,ICDate,ICChinhSua,ICBack,ICMuaNgay,ICLogoGCDK, ICBackHeader, ICBreadCum, ICThanhCong, ICUser2,
  ICMST, ICDiaChiVAT, ICCongTy, ICXoa2, ICErr,ICAddress, ICMail, ICMst, LogoMIC,

  BannerDK, QuyenLoi, QuyTrinhBoiThuong, khienBaoHiem, TaiNanGapPhai, Banner2, Banner3,CCCD,

  BannerMB, QuyenLoiMB, QuyTrinhBoiThuongMB, TaiNanGapPhaiMB, Banner2MB, Banner3MB, CCCDMB
};

export default variable;
